"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Spacer = function (_a) {
    var h = _a.h, w = _a.w, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, {
            // HEIGHT
            'br-h-1': h === 1,
            'br-h-2': h === 2,
            'br-h-3': h === 3,
            'br-h-4': h === 4,
            'br-h-5': h === 5,
            'br-h-6': h === 6,
            'br-h-8': h === 8,
            'br-h-10': h === 10,
            // WIDTH
            'br-w-1': w === 1,
            'br-w-2': w === 2,
            'br-w-3': w === 3,
            'br-w-4': w === 4,
            'br-w-5': w === 5,
            'br-w-6': w === 6,
            'br-w-8': w === 8,
            'br-w-10': w === 10
        }) }));
};
exports.Spacer = Spacer;
